/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom'
import React from 'react'
import utils from '../../utils'
import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

function Footer() {
    return (
        <footer className="bg-gray-900  text-gray-300 py-12 pb-20">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div>
                        <h3 className="font-bold text-lg text-white mb-4 uppercase">{utils.siteName}</h3>
                        <p className="text-sm">Kenya&apos;s most preferred online store.</p>
                        <a href="tel:+254796469611">
                            <p className="text-sm mt-4 flex items-center"><FaPhone className='text-base mr-2' /> +254 796 469 611</p>
                        </a>
                        <a href="mailto:hello@koova.co.ke">
                            <p className="text-sm mt-2 flex items-center"><MdEmail className='text-base mr-2' /> hello@koova.co.ke</p>
                        </a>
                    </div>
                    <div>
                        <h3 className="font-bold text-lg text-white mb-4">COMPANY</h3>
                        <ul className="space-y-2 text-sm">
                            <li><Link className="hover:text-secondary" to="/">Home</Link></li>
                            <li><Link className="hover:text-secondary" to="/cart">Cart</Link></li>
                            <li><Link className="hover:text-secondary" to="/products">Products</Link></li>
                            <li><Link className="hover:text-secondary" to="/categories">Categories</Link></li>
                            <li><Link className="hover:text-secondary" to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-bold text-lg text-white mb-4">POLICY INFO</h3>
                        <ul className="space-y-2 text-sm">
                            <li><Link className="hover:text-secondary" to="/refund">Refund Policy</Link></li>
                            <li><Link className="hover:text-secondary" to="/policy">Privacy Policy</Link></li>
                            <li><Link className="hover:text-secondary" to="/billings">Payments & Billings</Link></li>
                            <li><Link className="hover:text-secondary" to="/cookies">Cookies Notice</Link></li>
                            <li><Link className="hover:text-secondary" to="/terms">Terms & Conditions</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-bold text-lg text-white mb-4">WHY US?</h3>
                        <ul className="space-y-2 text-sm">
                            <li><Link className="hover:text-secondary" to="/about">About</Link></li>
                            <li><a className="hover:text-secondary" href="#">Money Back Guarantee</a></li>
                            <li><a className="hover:text-secondary" href="#">Quality Guarantee</a></li>
                            <li><a className="hover:text-secondary" href="#">Secure Shopping</a></li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm text-gray-500">
                    <p>© {new Date().getFullYear()} {utils.siteName} LTD. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer